(function () {
  const STORAGE_KEY = 'ptb-cookie-consent';
  const EMBED_SELECTOR = '[data-consent-src]';

  function getChoice() {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function hasConsent() {
    return getChoice() === 'accepted';
  }

  function isDismissed() {
    return getChoice() === 'dismissed';
  }

  function setChoice(value) {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {
      /* storage blocked */
    }
  }

  function getBanner() {
    return document.getElementById('cookie-consent-banner');
  }

  function showBanner() {
    var banner = getBanner();
    if (!banner) return;
    banner.removeAttribute('hidden');
  }

  function hideBanner() {
    var banner = getBanner();
    if (banner) banner.setAttribute('hidden', '');
  }

  function getBannerFocusables() {
    var banner = getBanner();
    if (!banner) return [];
    return Array.prototype.slice.call(
      banner.querySelectorAll(
        'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    );
  }

  function focusBanner() {
    var items = getBannerFocusables();
    if (items.length) items[0].focus();
  }

  function loadEmbeds() {
    document.querySelectorAll(EMBED_SELECTOR).forEach(function (el) {
      var src = el.getAttribute('data-consent-src');
      if (!src || el.getAttribute('src')) return;

      el.setAttribute('src', src);
      el.removeAttribute('hidden');
      el.classList.remove('consent-embed');

      var wrapper = el.closest('[data-consent-wrapper]');
      if (!wrapper) return;

      var placeholder = wrapper.querySelector('[data-consent-placeholder]');
      if (placeholder) placeholder.setAttribute('hidden', '');
    });
  }

  function accept() {
    setChoice('accepted');
    hideBanner();
    loadEmbeds();
    document.dispatchEvent(new CustomEvent('ptb:cookie-consent'));
  }

  function dismissBanner() {
    setChoice('dismissed');
    hideBanner();
  }

  function dismiss(event) {
    var btn = event && event.currentTarget;
    var banner = getBanner();

    if (!btn) {
      dismissBanner();
      return;
    }

    if (banner && banner.contains(btn)) {
      dismissBanner();
      return;
    }

    var gate = btn.closest('[data-consent-placeholder]');
    if (gate) gate.setAttribute('hidden', '');
  }

  function onBannerKeydown(event) {
    var banner = getBanner();
    if (!banner || banner.hasAttribute('hidden')) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      dismiss();
      return;
    }

    if (event.key !== 'Tab') return;

    var items = getBannerFocusables();
    if (!items.length) return;

    var first = items[0];
    var last = items[items.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function bindButtons() {
    document.querySelectorAll('[data-cookie-accept]').forEach(function (btn) {
      btn.addEventListener('click', accept);
    });
    document.querySelectorAll('[data-cookie-dismiss]').forEach(function (btn) {
      btn.addEventListener('click', dismiss);
    });
  }

  function init() {
    bindButtons();
    document.addEventListener('keydown', onBannerKeydown);

    if (hasConsent()) {
      hideBanner();
      loadEmbeds();
      return;
    }

    if (isDismissed()) {
      hideBanner();
      return;
    }

    document.querySelectorAll(EMBED_SELECTOR).forEach(function (el) {
      el.classList.add('consent-embed');
      el.setAttribute('hidden', '');
    });

    showBanner();
    focusBanner();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
